import { IconVolume, IconVolumeOff } from '@tabler/icons-react';
import { LazyMotion, domAnimation, m } from 'motion/react';
import { Tooltip } from '@caddie/ui-kit/components/tooltip';
import { cn } from './utils/styles';
import { CADDIE_Z_INDEX } from '../constants/z-index';

export function TtsMuteButton({
  isMuted,
  onClick,
  color,
}: {
  isMuted: boolean;
  onClick: () => void;
  color: string;
}) {
  return (
    <LazyMotion features={domAnimation}>
      <Tooltip
        label="Read aloud"
        position="top"
        withArrow
        zIndex={CADDIE_Z_INDEX.MENU}
      >
        <m.button
          type="button"
          onClick={onClick}
          aria-label={isMuted ? 'Unmute audio' : 'Mute audio'}
          initial={{ opacity: 0, scale: 0.85 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.16, ease: 'easeOut' }}
          className={cn(
            'caddie-tts-mute-btn caddietw-border-0 caddietw-appearance-none caddietw-cursor-pointer caddietw-bg-transparent',
            'caddietw-flex caddietw-items-center caddietw-justify-center',
            'caddietw-rounded-full caddietw-w-[34px] caddietw-h-[34px]',
            'caddietw-transition-opacity',
            isMuted ? 'caddietw-opacity-30' : 'caddietw-opacity-50'
          )}
          style={{ '--caddie-tts-btn-color': color } as React.CSSProperties}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          {isMuted ? <IconVolumeOff size={20} /> : <IconVolume size={20} />}
        </m.button>
      </Tooltip>
    </LazyMotion>
  );
}
